/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showstopbutton2Inputs */

const en_entity_showstopbutton2 = /** @type {(inputs: Entity_Showstopbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Stop Button`)
};

const de_entity_showstopbutton2 = /** @type {(inputs: Entity_Showstopbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopp-Button anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Stop Button" |
*
* @param {Entity_Showstopbutton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showstopbutton2 = /** @type {((inputs?: Entity_Showstopbutton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showstopbutton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showstopbutton2(inputs)
	return de_entity_showstopbutton2(inputs)
});
export { entity_showstopbutton2 as "entity_showStopButton" }